import { SvgLineChart } from "./SvgLineChart";
import "./AccuracyTrendChart.css";

/**
 * Phase 18 WU-18.E4 — cross-job-type OCR accuracy trend.
 *
 * Dumb presentational: wraps `SvgLineChart` with an accuracy-as-percent Y
 * axis. Reuses the existing chart component instead of introducing a new
 * one. Per-job-type `AccuracyDashboard` stays on `JobTypeDetailPage`.
 */
export interface AccuracyTrendPoint {
  date: string;
  accuracy: number;
  totalFields: number;
  totalCorrections: number;
}

export interface AccuracyTrendChartProps {
  trend: AccuracyTrendPoint[];
}

export function AccuracyTrendChart({ trend }: AccuracyTrendChartProps) {
  if (trend.length === 0) {
    return (
      <div className="accuracy-trend__empty" data-testid="accuracy-trend-empty">
        No accuracy trend data for this period.
      </div>
    );
  }

  const data = trend.map((p) => ({
    label: p.date.slice(5),
    value: Math.round(p.accuracy * 1000) / 10, // percent (1 decimal)
  }));

  return (
    <div className="accuracy-trend" data-testid="accuracy-trend">
      <SvgLineChart data={data} color="#4caf50" height={220} label="Accuracy %" />
    </div>
  );
}
